export default __webpack_public_path__ + "static/media/Summoner's Boots of the Mandate.9a927c0b.jpg";